import { Injectable } from "@nestjs/common";
import { AssetStatusEnum } from "libs/shared-models/common-models/src/lib/enum/asset-status.enum";
import { Assets } from "../open-assets/open-assets-entity";
import { AssetMaintainanceTransactionsDto } from "./dto/asset-maintainance-transactions.dto";
import { AssetMaintainanceDto } from "./dto/asset-maintainance.dto";
import { AssetMaintainanceTransactions } from "./entity/asset-maintainance-transactions.entity";
import { AssetMaintainance } from "./entity/asset-maintainance.entity";

@Injectable()
export class AssetMaintainanceAdapter{
    public convertDtotoAssetMaintainanceEntity(assetMaintainanceDto:AssetMaintainanceDto,isUpdate: boolean = false) : AssetMaintainance{
        const assetMaintainance = new AssetMaintainance();
        assetMaintainance.assetsId = new Assets()
        assetMaintainance.assetsId.assetId = assetMaintainanceDto.assetId;
        assetMaintainance.assetLocationId = assetMaintainanceDto.assetLocationId;
        assetMaintainance.assetCondition = assetMaintainanceDto.assetCondition;
        assetMaintainance.maintainanceFrequencyInDays = assetMaintainanceDto.maintainanceFrequencyInDays;
        assetMaintainance.assigned = assetMaintainanceDto.assigned;
        assetMaintainance.maintainanceType = assetMaintainanceDto.maintainanceType;
        assetMaintainance.owner = assetMaintainanceDto.owner;
        assetMaintainance.expiredDate = assetMaintainanceDto.expiredDate;
        assetMaintainance.costOfRepair = assetMaintainanceDto.costOfRepair;
        assetMaintainance.damageReason = assetMaintainanceDto.damageReason;
        assetMaintainance.canbeReused = assetMaintainanceDto.canbeReused;
        assetMaintainance.status = AssetStatusEnum.Undermaintenance;
        assetMaintainance.remarks = assetMaintainanceDto.remarks;
        assetMaintainance.isActive = assetMaintainanceDto.isActive == undefined ? true : assetMaintainanceDto.isActive;
        // if(assetMaintainanceDto.assetMaintainanceTransactions){
        //     const assetMaintainanceTransactions : AssetMaintainanceTransactions[] = [];
        //     for(const assetTransactionDto of assetMaintainanceDto.assetMaintainanceTransactions) {
        //         const assetTransactions = new AssetMaintainanceTransactions();
        //         if(isUpdate){
        //             assetTransactions.assetMaintainanceTransactionsId = assetTransactionDto.assetMaintainanceTransactionsId;
        //         }
        //             assetTransactions.assetMaintainanceId = assetTransactionDto.assetMaintainanceId;
        //             assetTransactions.maintainanceType = assetTransactionDto.maintainanceType;
        //             assetTransactions.maintainanceValue = assetTransactionDto.maintainanceValue;
        //             assetTransactions.isActive = assetTransactionDto.isActive;
        //             assetMaintainanceTransactions.push(assetTransactions)

        //     }
        //     assetMaintainance.assetMaintainanceTransactions = assetMaintainanceTransactions
        //     if(isUpdate){
        //         assetMaintainance.updatedUser = assetMaintainance.updatedUser
        //     }else{
        //         assetMaintainance.isActive = true
        //     }

        // }
        return assetMaintainance;

    }

    public convertDtotoAssetMaintainanceTransEntity(assetMaintainanceDto:AssetMaintainanceTransactionsDto,isUpdate: boolean = false) : AssetMaintainanceTransactions{
        const assetMaintainance = new AssetMaintainanceTransactions();
        assetMaintainance.assetMaintainanceTransactionsId = assetMaintainanceDto.assetMaintainanceTransactionsId;
        assetMaintainance.assetMaintainance = new AssetMaintainance();
        assetMaintainance.assetMaintainance.assetMaintainanceId = assetMaintainanceDto.assetMaintainanceId;
        assetMaintainance.assetCondition = assetMaintainanceDto.assetCondition;
        assetMaintainance.assetId = assetMaintainanceDto.assetId;
        assetMaintainance.assetLocationId = assetMaintainanceDto.assetLocationId;
        assetMaintainance.assigned = assetMaintainanceDto.assigned;
        assetMaintainance.costOfRepair = assetMaintainanceDto.costOfRepair;
        assetMaintainance.damageReason = assetMaintainanceDto.damageReason;
        assetMaintainance.canbeReused = assetMaintainanceDto.canbeReused;
        assetMaintainance.maintainanceFrequencyInDays = assetMaintainanceDto.maintainanceFrequencyInDays;
        assetMaintainance.remarks = assetMaintainanceDto.remarks;
        assetMaintainance.status = assetMaintainanceDto.status;
        assetMaintainance.maintainanceType = assetMaintainanceDto.maintainanceType;
        assetMaintainance.createdAt = assetMaintainanceDto.createdAt;
        assetMaintainance.updatedAt = assetMaintainanceDto.updatedAt;
        assetMaintainance.owner = assetMaintainanceDto.owner;
        assetMaintainance.isActive = assetMaintainanceDto.isActive == undefined ? true : assetMaintainanceDto.isActive;
        
        return assetMaintainance;
    }

    public convertEntityToDto(maintainanceObject:AssetMaintainance) : AssetMaintainanceDto{
        const maintainanceDto = new AssetMaintainanceDto;
        maintainanceDto.assetMaintainanceId = maintainanceObject.assetMaintainanceId;   
        // maintainanceDto.assetId = maintainanceObject.assetsId.assetId;
        maintainanceDto.assetLocationId = maintainanceObject.assetLocationId;
        maintainanceDto.assigned = maintainanceObject.assigned;
        maintainanceDto.costOfRepair = maintainanceObject.costOfRepair;
        maintainanceDto.expiredDate = maintainanceObject.expiredDate;
        maintainanceDto.maintainanceFrequencyInDays = maintainanceObject.maintainanceFrequencyInDays;
        maintainanceDto.maintainanceType = maintainanceObject.maintainanceType;
        maintainanceDto.owner = maintainanceObject.owner;
        maintainanceDto.canbeReused = maintainanceObject.canbeReused;
        maintainanceDto.damageReason = maintainanceObject.damageReason;
        maintainanceDto.remarks = maintainanceObject.remarks;
        maintainanceDto.status = maintainanceObject.status;
        maintainanceDto.createdAt = maintainanceObject.createdAt;
        maintainanceDto.createdUser = maintainanceObject.createdUser;
        maintainanceDto.isActive = maintainanceObject.isActive;
        maintainanceDto.updatedAt = maintainanceObject.updatedAt;
        maintainanceDto.updatedUser = maintainanceObject.updatedUser;
        maintainanceDto.versionFlag = maintainanceObject.versionFlag;
        return maintainanceDto;
    }

    public convertEntityToTransDto(maintainanceObject:AssetMaintainanceTransactions) : AssetMaintainanceTransactionsDto{
        const maintainanceDto = new AssetMaintainanceTransactionsDto;


        maintainanceDto.assetMaintainanceTransactionsId = maintainanceObject.assetMaintainanceTransactionsId;
        maintainanceDto.assetMaintainanceId = maintainanceObject.assetMaintainanceId;   
        maintainanceDto.assetId = maintainanceObject.assetId;
        maintainanceDto.assetLocationId = maintainanceObject.assetLocationId;
        maintainanceDto.assigned = maintainanceObject.assigned;
        maintainanceDto.costOfRepair = maintainanceObject.costOfRepair;
        maintainanceDto.expiredDate = maintainanceObject.expiredDate;
        maintainanceDto.maintainanceFrequencyInDays = maintainanceObject.maintainanceFrequencyInDays;
        maintainanceDto.maintainanceType = maintainanceObject.maintainanceType;
        maintainanceDto.owner = maintainanceObject.owner;
        maintainanceDto.canbeReused = maintainanceObject.canbeReused;
        maintainanceDto.damageReason = maintainanceObject.damageReason;
        maintainanceDto.remarks = maintainanceObject.remarks;
        maintainanceDto.status = maintainanceObject.status;
        maintainanceDto.createdAt = maintainanceObject.createdAt;
        maintainanceDto.createdUser = maintainanceObject.createdUser;
        maintainanceDto.isActive = maintainanceObject.isActive;
        maintainanceDto.updatedAt = maintainanceObject.updatedAt;
        maintainanceDto.updatedUser = maintainanceObject.updatedUser;
        maintainanceDto.versionFlag = maintainanceObject.versionFlag;
        return maintainanceDto;
    }
}